module.exports = __webpack_public_path__ + "img/smile-logo-white.ddc8d97a.svg";